module.exports = __webpack_public_path__ + "static/img/banner31.1fc238f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainpage/banner31.jpg
// module id = Aqmr
// module chunks = 18